export default {
    searchFilter: (str, subStr) => {
        return str.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').includes(subStr.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''));
    },
    generateAlphanumericHash: (length) => {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';
        for (let i = 0; i < length; i++) {
            const randomIndex = Math.floor(Math.random() * characters.length);
            result += characters[randomIndex];
        }
        return result;
    },
    getRandomString: (minLength, maxLength) => {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const length = Math.floor(Math.random() * (maxLength - minLength + 1)) + minLength;
        let result = '';

        for (let i = 0; i < length; i++) {
            result += chars.charAt(Math.floor(Math.random() * chars.length));
        }

        return result;
    }
};

